import { ReactNode } from 'react';

import { SectionBlock } from '../../../../../blocks/SectionBlock';
import { Spinner } from '../../../../../components/Spinner';

interface TimelineSectionProps {
  title: string;
  isLoading: boolean;
  isEmpty: boolean;
  emptyMessage: string;
  children: ReactNode;
}

export function TimelineSection({
  title,
  isLoading,
  isEmpty,
  emptyMessage,
  children,
}: TimelineSectionProps): JSX.Element {
  const renderContent = (): ReactNode => {
    if (isLoading) {
      return (
        <div className="flex justify-center items-center h-48">
          <Spinner />
        </div>
      );
    }

    if (isEmpty) {
      return (
        <div className="flex justify-center items-center h-48 text-gray-500">
          {emptyMessage}
        </div>
      );
    }

    return children;
  };

  return <SectionBlock title={title}>{renderContent()}</SectionBlock>;
}
